import {ordersApi} from './Api';
import {AxiosResponse} from "axios";
import {AvailableTicket} from "../containers/Event/types";

const TicketService = (() => {
	function getAvailableTickets(eventId: string): Promise<AxiosResponse> {
		const params = { appType: 'WEB'}
		return ordersApi.get(`/v1/public/event/${eventId}/tickets-available`, { params });
	}

	function getAvailableTicketsByEventDate(eventId: string, eventDateId: string): Promise<AxiosResponse<AvailableTicket[]>> {
		return ordersApi.get(`/v1/public/event/${eventId}/event-date/${eventDateId}/tickets-available`);
	}

	return {
		getAvailableTickets,
		getAvailableTicketsByEventDate
	}
})();

export default TicketService;
